import requestFunctions from "../../functions/requestFunctions";


export const state = {
  ORDERS_ITEM: {},
  ORDERS_LIST: [],
  ORDERS_TABLE_DATA: [],
  ORDERS_TABLE_PRODUCTS_DATA: [],
  ORDERS_ARRAY_DATA: [],
  ORDERS_TOTAL_ROWS: 0
}

export const getters = {
  GET_ORDERS_ITEM: (state) => {
    return state.ORDERS_ITEM;
  },
  GET_ORDERS_LIST: (state) => {
    return state.ORDERS_LIST;
  },
  GET_ORDERS_TABLE_DATA: (state) => {
    return state.ORDERS_TABLE_DATA;
  },
  GET_ORDERS_TABLE_PRODUCTS_DATA: (state) => {
    return state.ORDERS_TABLE_PRODUCTS_DATA;
  },
  GET_ORDERS_ARRAY_DATA: (state) => {
    return state.ORDERS_ARRAY_DATA;
  },
  GET_ORDERS_TOTAL_ROWS: (state) => {
    return state.ORDERS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_ORDERS_ITEM(state, item) {
    state.ORDERS_ITEM = item;
  },

  UPDATE_ORDERS_TABLE_PRODUCTS_DATA(state, list) {

    list = list.data;

    state.ORDERS_TABLE_PRODUCTS_DATA = [];

    list.forEach(el => {
      state.ORDERS_TABLE_PRODUCTS_DATA.push({
        'uuid'   : el.uuid,
        'product_name': el.product_name,
        'product_uuid': el.product_uuid,
        'product_id': el.product_id,
        'qnt': el.qnt,
        'cost': el.cost,
        'sum': el.sum,
        'unit_name': el.unit_name,
        'unit_code': el.unit_code,
        'created_at': el.created_at,
        'updated_at': el.updated_at,
      });
    });
  },

  UPDATE_ORDERS_LIST(state, list) {

    state.ORDERS_LIST = list.data;

    state.ORDERS_TOTAL_ROWS = list.total;
    list = list.data;

    state.ORDERS_TABLE_DATA = [];
    state.ORDERS_ARRAY_DATA = [];

    list.forEach(el => {

      let status = {
        'draft'    : 'Черновик',
        'opened'   : 'Открыт',
        'canceled' : 'Отменен',
        'closed'   : 'Закрыт',
        'check'    : 'Проверить'
      }

      state.ORDERS_TABLE_DATA.push({
        'uuid'   : el.uuid,
        'id'     : el.id,
        'number' : el.number,
        'document_date' : el.document_date,
        'sum'    : el.sum,
        'client_type' : el.client_type,
        'counterparty_name' : el.counterparty_name,
        'marketplace_name'  : el.marketplace_name,
        'shop_name'    : el.shop_name,
        'company_name' : el.company_name,
        'comments' : el.comments,
        'status': status[el.status] ? status[el.status] : '',
        'created_at'   : el.created_at,
        'updated_at'   : el.updated_at,
      });

      state.ORDERS_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        number: el.number,
        sum: el.sum,
      });
    });
  },
}

export const actions = {

  async FETCH_ORDERS_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/orders/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ORDERS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_ORDERS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/orders';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ORDERS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_ORDERS_LIST_PRODUCTS({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/orders/' + payload.uuid + '/products';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ORDERS_TABLE_PRODUCTS_DATA', response.data);
      return response.data;
    }
  },

  async FETCH_ORDERS_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/orders';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_ORDERS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/orders/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_ORDERS_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/orders/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}